import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { User } from '@core/models';

@Component({
	selector: 'app-premvip-tab',
	templateUrl: './premvip-tab.component.html',
	styleUrls: ['./premvip-tab.component.scss'],
})
export class PremvipTabComponent implements OnInit {
	selectedVal: string;
	deviceInfo: DeviceInfo;
	data: any;
	user: User = this.auth.user();
	embedded: boolean = false;
	queryAdID: string;
	constructor(
		private deviceDetectorService: DeviceDetectorService,
		public router: Router,
		public route: ActivatedRoute,
		public locale: LocaleService,
		public viewport: ViewportService,
		private auth: AuthService
	) {}

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			this.queryAdID = queries['adID'];
			this.embedded = queries['embedded'];

			if (queries['selectedValue'] !== undefined) {
				this.selectedVal = queries['selectedValue'];
			}
		});
	}
}
